import { Form, Input , Checkbox,  } from "antd";
import React from "react";
import DeselectableRadioGroup from "../../../../../blocks/FormItems/DeselectableRadioGroup";
import {
  daysUptoFifteenOptions,
  weeksStartingFourOptions,
  weeksStartingTwoOptions,
} from "../../../../IpEMR/Options/physioOptions";
import DynamicInputFields from "../../../../../blocks/FormItems/DynamicInputFields";
const NeuroTherapy = ({ onValuesChange, formData }) => {
  const [form] = Form.useForm();
  const selectedTherapy = Form.useWatch("others", form);
  const showOthers = selectedTherapy ?? false;
  return (
    <>
      <Form
        id="neuro-therapy"
        form={form}
        onValuesChange={(cur, all) => onValuesChange("therapy", all)}
        layout="vertical"
        className="ip-forms"
        initialValues={formData?.therapy}
      >
        <DeselectableRadioGroup
          name={"stroke_rehab"}
          label={"Stroke Rehab"}
          options={weeksStartingFourOptions}
          form={form}
        />
        <Form.Item name={"brustromme_approach"} label={"Brustromme Approach"}>
          <Input placeholder="Brustromme Approach" />
        </Form.Item>
        <Form.Item name={"mrp_approach"} label={"MRP Approach"}>
          <Input placeholder="MRP Approach" />
        </Form.Item>
        <Form.Item name={"ndt_approach"}label={"NDT Approach"}>
          <Input placeholder="NDT Approach" />
        </Form.Item>
        <Form.Item name={"cimt_approach"}label={"CIMT Approach"}>
          <Input placeholder="CIMT Approach" />
        </Form.Item>
        <Form.Item name={"vojta_approach"} label={"VOJTA Approach"}>
          <Input placeholder="VOJTA Approach" />
        </Form.Item>
        <Form.Item name={"pnf_approach"}label={"PNF Approach"}>
          <Input placeholder="PNF Approach" />
        </Form.Item>
        <Form.Item name={"electic_approach"} label={"Electic Approach"}>
          <Input placeholder="Electic Approach" />
        </Form.Item>
        <Form.Item name={"roods_approach"} label={"ROODS Approach"}>
          <Input placeholder="ROODS Approach" />
        </Form.Item>
        <Form.Item name={"speech_therapy"} label={"Speech Approach"}>
          <Input placeholder="Speech therapy" />
        </Form.Item>
        <Form.Item name={"electrical_muscle_stimulation"} label={"Electrical Muscle Stimulation "}>
          <Input placeholder="Electrical Muscle Stimulation" />
        </Form.Item>
        <Form.Item name={"mile_stone_training"}label={"Mile Stone Training"}>
          <Input placeholder="Mile Stone Training" />
        </Form.Item>
        <Form.Item name={"cognitive_rehab"}label={"Cognitive Rehab"}>
          <Input placeholder="Cognitive Rehab" />
        </Form.Item>
        <Form.Item name={"neuro_conditioning_training"}label={"Neuro Conditioning Training"}>
          <Input placeholder="Neuro Conditioning Training" />
        </Form.Item>
        <Form.Item name={"sensory_integration"}label={"Sensory Integration"}>
          <Input placeholder="Sensory Integration" />
        </Form.Item>
        <Form.Item name={"adl_training"}label={"ADL Training"}>
          <Input placeholder="ADL Training" />
        </Form.Item>
        <Form.Item name={"wheel_chair_training"}label={"Wheel Chair Training"}>
          <Input placeholder="Wheel Chair Training" />
        </Form.Item>

        <DeselectableRadioGroup
          name={"ultrasound"}
          label={"Ultrasound"}
          options={daysUptoFifteenOptions}
          form={form}
        />

        <DeselectableRadioGroup
          name={"splinting"}
          label={"Splinting/Bracing"}
          options={weeksStartingTwoOptions}
          form={form}
        />
        <Form.Item name={"postural_correction"} label={"Splinting/Postural Correction"}>
          <Input placeholder="Postural Correction" />
        </Form.Item>
        <Form.Item name={"robotics"} label={"Robotics/Bracing"}>
          <Input placeholder="Robotics" />
        </Form.Item>
        <Form.Item name={"gait_training"} label={"Gait Training"}>
          <Input placeholder="Gait Training" />
        </Form.Item>
        <Form.Item name={"description"}label={"Description"}>
          <Input placeholder="Please enter the description" />
        </Form.Item>
        <Form.Item name={"others"} valuePropName="checked">
          <Checkbox>Others</Checkbox>
        </Form.Item>
        {showOthers && (
          <DynamicInputFields
            field_key={"others"}
            form={form}
            inputStyle={{ maxWidth: 800 }}
          />
        )}
      </Form>
    </>
  );
};

export default NeuroTherapy;
